export default __webpack_public_path__ + "static/media/image-not-available.26982bc5.png";